import { UserAvatar } from "@components/avatar/UserAvatar";
import type { TransactionRuleReviewWithReviewer } from "@common/schemas/transactionRuleReview.schema";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { timeAgo } from "@helpers/date";
import { CheckIcon } from "@icons";

interface RuleReviewedCheckProps {
    readonly reviews: readonly TransactionRuleReviewWithReviewer[];
}

export const RuleReviewedCheck = ({ reviews }: RuleReviewedCheckProps) => {
    if (reviews.length === 0) {
        return null;
    }

    return (
        <Tooltip
            title="Reviewed"
            content={
                <VStack gap={4}>
                    {reviews.map(({ id, reviewer, createdAt }) => (
                        <HStack key={id} gap={8} align="center">
                            <UserAvatar user={reviewer} size="xs" aria-hidden />
                            <span>
                                {reviewer.name} · {timeAgo(createdAt)}
                            </span>
                        </HStack>
                    ))}
                </VStack>
            }
        >
            <span role="img" aria-label="Reviewed">
                <CheckIcon className="icon-color-gray-600" />
            </span>
        </Tooltip>
    );
};
